import { HttpBaseApiWrapper } from 'service/HttpBaseApiWrapper'
import { URLPrefix } from 'service/url'

import { CreateBookingTemplate, IBookingTemplate, UpdateBookingTemplate } from './BookingTemplate'

type IBookingTemplatesListParams = {
  modes?: string[]
  types?: string[]
  sort?: string
  from: number
  size?: number
}

interface IBookingTemplatesResponseJSON {
  templates: IBookingTemplate[]
  total: number
}

interface BookingTemplateServiceProps {
  http: HttpBaseApiWrapper
}

export class BookingTemplateService {
  http: HttpBaseApiWrapper

  constructor(props: BookingTemplateServiceProps) {
    this.http = props.http
  }

  getBookingTemplates = (params: IBookingTemplatesListParams): Promise<IBookingTemplatesResponseJSON> => {
    return this.http.get<IBookingTemplatesResponseJSON>('/bookingTemplates', {
      params,
      urlPrefix: URLPrefix.Root,
    })
  }

  getBookingTemplate = (templateId: string): Promise<IBookingTemplate> => {
    return this.http.get<IBookingTemplate>(`/bookingTemplates/${templateId}`, {
      urlPrefix: URLPrefix.Root,
    })
  }

  createBookingTemplate = (template: CreateBookingTemplate): Promise<IBookingTemplate> => {
    return this.http.post<IBookingTemplate>('/bookingTemplates', template, {
      urlPrefix: URLPrefix.Root,
    })
  }

  editBookingTemplate = (templateId: string, template: UpdateBookingTemplate): Promise<IBookingTemplate> => {
    return this.http.put<IBookingTemplate>(`/bookingTemplates/${templateId}`, template, {
      urlPrefix: URLPrefix.Root,
    })
  }

  deleteBookingTemplate = (templateId: string): Promise<void> => {
    // @ts-expect-error TS(2345) FIXME: Argument of type 'null' is not assignable to param... Remove this comment to see the full error message
    return this.http.delete<void>(`/bookingTemplates/${templateId}`, null, {
      urlPrefix: URLPrefix.Root,
    })
  }
}
